import React from 'react'
import { useLocalState } from '../../../../shared/UseLocalState'
import { ExamDto } from '../../../../api'
import { actualShowState } from '../../../../state/ActualShow.state'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { registrationState } from '../Registration.state'

export const ExamsScreen = () => { 
  /* STATE */

    const exams = useLocalState<ExamDto[]>(actualShowState.actualShowExams$, actualShowState.actualShowExams$.value)
    const selectedExams = useLocalState<ExamDto[]>(registrationState.selectedExams$, registrationState.selectedExams$.value)

  /* TEMPLATE */
    /* no select
              isDataSelectable={() => false}
          rowClassName={() => 'p-disabled'}

    */
    return (
    <div>
      <div>
        <h2>Verfügbare Prüfungen. Bei Storno Prüfung abwählen</h2>
        <DataTable
          showSelectAll={false}
          showHeaders={true}
          value={exams}
          selectionMode='multiple'
          selection={selectedExams}
          onSelectionChange={(e) => registrationState.selectedExams$.next(e.value)}
        >
          <Column selectionMode='multiple' bodyStyle={{ width: '3rem' }} />
          <Column
            header='GWE Typ'
            field='gwetyp'
            body={(exam: ExamDto) => (
              <div>
                <b>{exam?.gweType}</b>
              </div>
            )}
          />

          <Column
            header='Name'
            field='name'
            body={(exam: ExamDto) => (
              <div>
                <b>{exam?.name}</b>
                <p>{exam?.description}</p>
              </div>
            )}
          />
        </DataTable>
      </div>
    </div>
  )
}
